import { Input, Component, ChangeDetectionStrategy } from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'tr-form-group-textbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './form-group-textbox.component.html',
  //styleUrls: ['./form-group-textbox.component.scss']
})
export class FormGroupTextboxComponent {

  @Input() control: FormControl;
  @Input() label: string;
  @Input() placeholder: string;
  @Input() inputType: string; // text, password, email
  @Input() addonClass: string;
  @Input() inputName: string;
  @Input() inputTitle: string;
  @Input() autoComplete: string; //Siddharth ADO-127091, fix for wcag2.2
}



// WEBPACK FOOTER //
// ./src/app/shared/components/form/form-group-textbox/form-group-textbox.component.ts